export const UnlockIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.83333 9.16826V5.83493C5.83229 4.80163 6.21523 3.80481 6.90781 3.03798C7.60039 2.27115 8.55319 1.78901 9.58125 1.68517C10.6093 1.58132 11.6393 1.86318 12.4712 2.47602C13.3032 3.08886 13.8777 3.98896 14.0833 5.00159M4.16667 9.16826H15.8333C16.7538 9.16826 17.5 9.91445 17.5 10.8349V16.6683C17.5 17.5887 16.7538 18.3349 15.8333 18.3349H4.16667C3.24619 18.3349 2.5 17.5887 2.5 16.6683V10.8349C2.5 9.91445 3.24619 9.16826 4.16667 9.16826Z"
      stroke="#00C48C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
